import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const DownloadBrochures = () => {
    const [activeTab, setActiveTab] = useState("english");

    const brochures = {
        english: [
            {
                title: "Aarogya EliteCare Plan",
                file: "assets/brochures/Aarogya_EliteCare.pdf",
            },
            {
                title: "Aarogya TotalCare Plan",
                file: "assets/brochures/Aarogya_TotalCare.pdf",
            },
            {
                title: "Aarogya SmartCare Plan",
                file: "assets/brochures/Aarogya_SmartCare.pdf",
            },
            {
                title: "Aarogya EasyCare Plan",
                file: "assets/brochures/Aarogya_EasyCare.pdf",
            },
        ],
        // hindi: [
        //     {
        //         title: "आरोग्यवर्धन स्वास्थ्य योजना",
        //         file: "assets/brochures/Arogyavardhan-Health-Plan-Hindi.pdf",
        //     },
        //     {
        //         title: "औषधि स्वास्थ्य योजना",
        //         file: "assets/brochures/Aushadhi-Health-Plan-Hindi.pdf",
        //     },
        //     {
        //         title: "आयुष स्वास्थ्य योजना",
        //         file: "assets/brochures/Ayush-Health-Plan-Hindi.pdf",
        //     },
        //     {
        //         title: "नियोग स्वास्थ्य योजना",
        //         file: "assets/brochures/Niyog-Health-Plan-Hindi.pdf",
        //     },
        //     {
        //         title: "प्रकृति स्वास्थ्य योजना",
        //         file: "assets/brochures/Prakriti-Health-Plan-Hindi.pdf",
        //     },
        // ],
    };


    return (
        <>
            {/* Page Banner */}
            <div className="page-banner overlay">
                <picture className="media media-bg max-md:!hidden">
                    <img
                        src="assets/img/banner/page-banner.jpg"
                        width={1920}
                        height={520}
                        loading="eager"
                        alt="Page Banner Image"
                    />
                </picture>
                <div className="page-banner-content">
                    <div className="container text-center">
                        <h1 className="heading text-80 fw-700 max-md:!text-[30px]">
                            Download Brochures
                        </h1>
                        <ul
                            className="breadcrumb list-unstyled"
                        >
                            <li>
                                <a
                                    href="/"
                                    className="text text-18"
                                    aria-label="Home Page"
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <svg
                                    width={8}
                                    height={12}
                                    viewBox="0 0 8 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.08929 5.40903C7.24552 5.5653 7.33328 5.77723 7.33328 5.9982C7.33328 6.21917 7.24552 6.43109 7.08929 6.58736L2.37512 11.3015C2.29825 11.3811 2.2063 11.4446 2.10463 11.4883C2.00296 11.532 1.89361 11.5549 1.78296 11.5559C1.67231 11.5569 1.56258 11.5358 1.46016 11.4939C1.35775 11.452 1.2647 11.3901 1.18646 11.3119C1.10822 11.2336 1.04634 11.1406 1.00444 11.0382C0.962537 10.9357 0.941453 10.826 0.942414 10.7154C0.943376 10.6047 0.966364 10.4954 1.01004 10.3937C1.05371 10.292 1.1172 10.2001 1.19679 10.1232L5.32179 5.9982L1.19679 1.8732C1.04499 1.71603 0.960996 1.50553 0.962894 1.28703C0.964793 1.06853 1.05243 0.859522 1.20694 0.705015C1.36145 0.550508 1.57046 0.462868 1.78896 0.460969C2.00745 0.45907 2.21795 0.543066 2.37512 0.694864L7.08929 5.40903Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </li>
                            <li>
                                <a role="link" aria-disabled="true" className="text text-18 active">
                                    Download Brochures
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* CONTENT SECTION */}
            <section className="relative w-full overflow-hidden">
                <div className="w-full pb-[80px] pt-[80px]">
                    <div className="container">
                        <div className="services-details-items">
                            <div className="row">
                                <div className="col-xl-12 w-full services-single-content">

                                    {/* 🔥 PILL TABS WITH ANIMATED UNDERLINE */}
                                    {/* <div className="inline-flex relative bg-white rounded-full p-1 shadow-sm border">
                                        {["english", "hindi"].map((tab) => (
                                            <button
                                                key={tab}
                                                onClick={() => setActiveTab(tab)}
                                                className={`relative z-10 px-6 py-2 text-sm font-medium rounded-full transition-colors ${activeTab === tab ? "text-white" : "text-gray-600 hover:text-[#0657A3]"}`}>
                                                {tab === "english" ? "English" : "हिंदी"}
                                                {activeTab === tab && (
                                                    <motion.span
                                                        layoutId="active-pill"
                                                        className="absolute inset-0 bg-[#0657A3] rounded-full -z-10"
                                                        transition={{
                                                            type: "spring",
                                                            stiffness: 500,
                                                            damping: 30,
                                                        }}/>
                                                )}
                                            </button>
                                        ))}
                                    </div> */}

                                    {/* 🔥 TAB CONTENT WITH SMOOTH TRANSITION */}
                                    <div className="mt-8 min-h-[200px]">
                                        <AnimatePresence mode="wait">
                                            <motion.div
                                                key={activeTab}
                                                initial={{ opacity: 0, y: 10 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                exit={{ opacity: 0, y: -10 }}
                                                transition={{ duration: 0.3 }}
                                                className="grid md:grid-cols-6 gap-6"
                                            >
                                                {brochures[activeTab].map((item, index) => (
                                                    <motion.div
                                                        key={item.title}
                                                        initial={{ opacity: 0, y: 15 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ delay: index * 0.08 }}
                                                        className="bg-white col-span-3 rounded-full border shadow-sm p-5 flex items-center justify-between hover:shadow-md transition-shadow max-md:block"
                                                    >
                                                        {/* Left: Title */}
                                                        <div>
                                                            <h4 className="text-base font-semibold text-secondary">
                                                                {item.title}
                                                            </h4>
                                                            <p className="text-xs text-gray-500 mt-1">PDF Document</p>
                                                        </div>

                                                        {/* Right: Download Button */}
                                                        <a
                                                            href={item.file}
                                                            target="new"
                                                            className="inline-flex items-center gap-2 text-sm font-medium text-white bg-[#0657A3] px-4 py-2 rounded-full hover:bg-[#176fa3] transition-colors max-md:mt-4"
                                                        >
                                                            View PDF
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="w-4 h-4"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M12 4v12m0 0l-4-4m4 4l4-4M4 20h16"
                                                                />
                                                            </svg>
                                                        </a>
                                                    </motion.div>
                                                ))}
                                            </motion.div>
                                        </AnimatePresence>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DownloadBrochures;
